export enum InterviewStatus {
    'nostatus'= 0,
    'scheduled' = 1,
    'interviewed' = 2,
    'noshow' = 3
}

export type CandidateDetails = {
    workHistory: string,
    interviewReliability: string,
    reviewsCount: number,
    score: number,
}
